import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
	Grid,
	TextField,
	FormControlLabel, FormControl, Checkbox, FormGroup, FormHelperText,
} from '@material-ui/core';

import {
	FormSelect,
	DatePicker,
	FormAutocomplete,
} from '@components/Coliving';

import PhoneInput from '../../../Coliving/components/PhoneInput';

import getOptions from './selectInputOptions';

import { useTranslation } from '@common/utils';

const additionalPersonsProps = {
	'name': 'additionalPersonName',
	'surname': 'additionalPersonSurname',
	'email': 'additionalPersonEmail',
	'phone': 'additionalPersonPhone',
	'address': 'additionalPersonAddress',
	'country': 'additionalPersonCountry',
	'birthday': 'additionalPersonBirthday',
	'gender': 'additionalPersonGender',
	'universityName': 'additionalPersonUniversity',
	'studyYear': 'additionalPersonStudyYear',
	'typeOfStudent': 'additionalPersonTypeOfStudent',
	'stayPurpose': 'additionalPersonStayPurpose',
	'faculty': 'additionalPersonFaculty',
	'otherUniversityName': 'additionalPersonOtherUniversityName',
	'otherFaculty': 'additionalPersonOtherFaculty',
	'idDocumentNo': 'additionalPersonIdDocumentNo',
	'universityNameFreeText': 'additionalPersonUniversityNameFreeText',
	'facultyFreeText': 'additionalPersonFacultyFreeText',
	'sourceOfDiscovery': 'additionalPersonSourceOfDiscovery',
};

const CheckOutInputsForm = ({ visibleCheckOutFormInputs = [], props = () => { }, roomReservation, isAdditional = false, index, values }) => {
	const tr = useTranslation();
	const { locale } = useSelector(state => state.locale);

	const options = getOptions();

	const stayPurposeValues = !isAdditional ? values.stayPurpose : values[`${additionalPersonsProps['stayPurpose']}${index}`];

	if (visibleCheckOutFormInputs.find(i => i.id === 'stayPurpose') && stayPurposeValues !== 'study') {
		visibleCheckOutFormInputs = visibleCheckOutFormInputs.filter(i => i.studyPurposeValueCondition !== 'study');
	}

	return (
		<>
			{visibleCheckOutFormInputs.filter(i => !i.companyField).map(input => {
				const prop = isAdditional && additionalPersonsProps[input.id] ? `${additionalPersonsProps[input.id]}${index}` : !isAdditional ? input.id : undefined;
				const i18n = input?.i18n || {};

				if (prop === 'faculty' && values.faculty === 'Other') {
					return (
						<>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<FormAutocomplete
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									{...props(prop)}
									required={input.required}
								/>
							</Grid>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<TextField fullWidth required={input.required} variant="outlined" label={tr('Faculty name')} {...props('otherFaculty')} />
							</Grid>
						</>
					);
				}

				if (prop === `additionalPersonFaculty${index}` && values[`additionalPersonFaculty${index}`] === 'Other') {
					return (
						<>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<FormAutocomplete
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									{...props(prop)}
									required={input.required}
								/>
							</Grid>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<TextField fullWidth required={input.required} variant="outlined" label={tr('Faculty name')} {...props(`additionalPersonOtherFaculty${index}`)} />
							</Grid>
						</>
					);
				}

				if (prop === 'universityName' && values.universityName === 'Other') {
					return (
						<>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<FormAutocomplete
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									{...props(prop)}
									required={input.required}
								/>
							</Grid>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<TextField fullWidth required={input.required} variant="outlined" label={tr('University name')} {...props('otherUniversityName')} />
							</Grid>
						</>
					);
				}

				if (prop === `additionalPersonUniversity${index}` && values[`additionalPersonUniversity${index}`] === 'Other') {
					return (
						<>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<FormAutocomplete
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									{...props(prop)}
									required={input.required}
								/>
							</Grid>
							<Grid item xs={12} sm={6} style={{ position: 'relative' }}>
								<TextField fullWidth required={input.required} variant="outlined" label={tr('University name')} {...props(`additionalPersonOtherUniversityName${index}`)} />
							</Grid>
						</>
					);
				}

				return (
					prop != null && (
						<Grid key={prop} item xs={12} sm={6} style={{ position: 'relative' }}>
							{(input.type === 'text' || input.type === 'email' || input.type === 'number') && (
								<TextField
									fullWidth
									required={input.required}
									variant="outlined"
									label={i18n[locale]?.alias || tr(input.label)}
									{...props(prop)}
								/>
							)}
							{input.type === 'date' && !input.withAdditionalProps && (
								<DatePicker
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									required={input.required}
									{...props(prop)}
								/>
							)}
							{input.type === 'date' && input.withAdditionalProps && (
								<DatePicker
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									{...props(prop)}
									minDate={roomReservation?.from}
									maxDate={roomReservation?.to}
									required={input.required}
									clearable
								/>
							)}
							{input.type === 'single-choice' && (
								<FormSelect
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									required={input.required}
									{...props(prop)}
								/>
							)}
							{input.type === 'autocomplete' && (
								<FormAutocomplete
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									required={input.required}
									{...props(prop)}
								/>
							)}
							{input.type === 'phone-number' && (
								<PhoneInput
									prop={prop}
									label={i18n[locale]?.alias || tr(input.label)}
									options={options[input.id]}
									required={input.required}
									{...props(prop)}
								/>
							)}
						</Grid>
					)
				);
			})}

			{!isAdditional && visibleCheckOutFormInputs.filter(i => i.companyField === true).map(input => {
				const prop = input.id || undefined;
				const i18n = input?.i18n || {};

				if (prop === 'company') {
					return (
						<Grid key={2} item xs={12}>
							<FormControl component="fieldset">
								<FormGroup>
									<FormControlLabel
										control={<Checkbox color="primary" value={values.company} onChange={() => props(prop).setFieldValue(prop, !values.company)} />}
										style={props(prop)?.touched['company'] && Boolean(props(prop)?.errors['company']) ? { color: '#f44336' } : {}}
										label={(
											<>
												{i18n[locale]?.alias || tr(input.label)}
												{props(prop)?.touched['company'] && Boolean(props(prop)?.errors['company']) &&
													<FormHelperText error={true}>{props(prop)?.touched['company'] ? props(prop)?.errors['company'] : ''}</FormHelperText>
												}
											</>
										)}
									/>
								</FormGroup>
							</FormControl>
						</Grid>
					);
				}
				if (values.company) {
					return (
						<Grid key={prop} item xs={12} sm={6} style={{ position: 'relative' }}>
							{(input.type === 'text' || input.type === 'email' || input.type === 'number') && (
								<TextField
									fullWidth
									required={input.required}
									variant="outlined"
									label={i18n[locale]?.alias || tr(input.label)}
									{...props(prop)}
								/>
							)}
						</Grid>
					);
				}
			})}
		</>
	);
};

CheckOutInputsForm.propTypes = {
	props: PropTypes.func.isRequired,
	visibleCheckOutFormInputs: PropTypes.array.isRequired,
	roomReservation: PropTypes.object,
	isAdditional: PropTypes.bool,
	index: PropTypes.bool,
	values: PropTypes.object.isRequired,
};

export default CheckOutInputsForm;
